import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconPlay } from '../../../base/icons/svg';
import { getLocalParticipant, isLocalParticipantModerator } from '../../../base/participants/functions';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { isFeatureEnabledForSession } from '../../../feature-controls/functions';
import { toggleSharedVideo } from '../../actions';
import { isSharingStatus } from '../../functions';
/**
 * Implements an {@link AbstractButton} to open the user documentation in a new window.
 */
class SharedVideoButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.sharedvideo';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.stopSharedVideo';
    icon = IconPlay;
    label = 'toolbar.sharedvideo';
    toggledLabel = 'toolbar.stopSharedVideo';
    tooltip = 'toolbar.sharedvideo';
    toggledTooltip = 'toolbar.stopSharedVideo';
    /**
     * Handles clicking / pressing the button, and opens a new dialog.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        this._doToggleSharedVideo();
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._sharingVideo;
    }
    /**
     * Indicates whether this button is disabled or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isDisabled() {
        return this.props._isDisabled;
    }
    /**
     * Dispatches an action to toggle video sharing.
     *
     * @private
     * @returns {void}
     */
    _doToggleSharedVideo() {
        this.props.dispatch(toggleSharedVideo());
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { ownerId, status: sharedVideoStatus } = state['features/shared-video'];
    const localParticipantId = getLocalParticipant(state)?.id;
    const isSharing = isSharingStatus(sharedVideoStatus ?? '');
    return {
        _isDisabled: isSharing && ownerId !== localParticipantId,
        _sharingVideo: isSharing,
        visible: isLocalParticipantModerator(state) && isFeatureEnabledForSession(state, 'sharedvideo')
    };
}
export default translate(connect(_mapStateToProps)(SharedVideoButton));
